var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeLaptop = function SvgIconAwesomeLaptop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.755,
    height: 20.604,
    viewBox: "0 0 25.755 20.604",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop",
    "data-name": "Icon awesome-laptop",
    d: "M25.111,16.741H15.354a1.269,1.269,0,0,1-1.318,1.288H11.59a1.367,1.367,0,0,1-1.319-1.288H.644A.646.646,0,0,0,0,17.385v.644A2.583,2.583,0,0,0,2.576,20.6h20.6a2.583,2.583,0,0,0,2.576-2.576v-.644A.646.646,0,0,0,25.111,16.741ZM23.18,1.932A1.937,1.937,0,0,0,21.248,0H4.507A1.937,1.937,0,0,0,2.576,1.932V15.453h20.6ZM20.6,12.878H5.151V2.576H20.6Z",
    fill: "#bcbcbc"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon awesome-laptop.ffebe39fbcf8d7421a8f939d305f782a.svg";